module.exports = __webpack_public_path__ + "img/xp3_desert.e05ade01.jpg";